import { useEffect, useState } from "react";
import api from "../../lib/api";

export function useCountdown(targetIso) {
    const [now, setNow] = useState(Date.now());
    useEffect(() => {
        const t = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(t);
    }, []);
    if (!targetIso) return { d: 0, h: 0, m: 0, s: 0, done: true };
    const target = new Date(targetIso).getTime();
    const diff = Math.max(0, target - now);
    const d = Math.floor(diff / (24 * 3600 * 1000));
    const h = Math.floor((diff / (3600 * 1000)) % 24);
    const m = Math.floor((diff / (60 * 1000)) % 60);
    const s = Math.floor((diff / 1000) % 60);
    return { d, h, m, s, done: diff === 0 };
}

export default function SuperBowlCountdown({ compact = false }) {
    const [cfg, setCfg] = useState(null);
    useEffect(() => { api.get("/football/config").then(r => setCfg(r.data)).catch(() => {}); }, []);
    const cd = useCountdown(cfg?.super_bowl_date);

    if (!cfg) return null;

    if (compact) {
        return (
            <div className="flex items-center gap-3 text-white/80" data-testid="sb-countdown-compact">
                <span className="text-[10px] uppercase tracking-[0.28em] text-white/50">{cfg.super_bowl_name}</span>
                <div className="flex gap-2 font-mono text-sm">
                    <span className="text-[#d4af37]">{cd.d}d</span>
                    <span>{String(cd.h).padStart(2,'0')}h</span>
                    <span>{String(cd.m).padStart(2,'0')}m</span>
                    <span className="text-white/50">{String(cd.s).padStart(2,'0')}s</span>
                </div>
            </div>
        );
    }

    return (
        <div className="surface p-8 md:p-10" data-testid="sb-countdown">
            <div className="section-label mb-4">Road to {cfg.super_bowl_name}</div>
            <div className="font-display text-4xl md:text-6xl text-white leading-tight tracking-tight">
                {cfg.super_bowl_stadium} · <span className="text-[#d4af37]">{cfg.super_bowl_city}</span>
            </div>
            <div className="text-white/50 text-sm mt-2">{new Date(cfg.super_bowl_date).toLocaleString("en-US", { dateStyle: "full", timeStyle: "short" })}</div>
            <div className="mt-8 grid grid-cols-4 gap-3 max-w-2xl">
                {[["Days", cd.d], ["Hours", cd.h], ["Minutes", cd.m], ["Seconds", cd.s]].map(([l, v]) => (
                    <div key={l} className="text-center border border-white/10 py-5 px-2 bg-black/40">
                        <div className="font-display text-4xl md:text-6xl text-[#d4af37] leading-none">{String(v).padStart(2,'0')}</div>
                        <div className="text-white/40 text-[10px] uppercase tracking-[0.24em] mt-3">{l}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}
